import request from '@/utils/request'

export function getRetentionRiskInsightOverview () {
  return request({
    url: '/addon/retentionRiskInsight/overview',
    method: 'get'
  })
}
